module.exports = __webpack_public_path__ + "img/security.e7ac4d20.png";